
<div class="bg-darkGrey">
  <div class="bg-white mx:flex sm:block justify-end mx:px-8 mx:py-2 sm:pr-4 mx:border-b mx:border-slate-200">
    <customer-select></customer-select>
  </div>
  
  <div class="dealer-portal-container mx:flex sm:block">
    <div class="dealer-portal__left mx:w-[75%] sm:w-[100%]">
      <div class="banner__image mx:hidden sm:block">
        <nz-carousel [nzEffect]="effect" [nzAutoPlay]="true" [ngStyle]="carouselImageStyle">
            <div 
              nz-carousel-content 
              class="cursor-pointer"
              *ngFor="let item of carouselList">
                  <div class="flex justify-center">
                      <img [src]="item.imageBase64"   [ngStyle]="carouselImageStyle" />
                  </div>
            </div>
        </nz-carousel>
      </div>
      <div class="bg-white mx:p-6 mx:mb-6 sm:p-4 sm:mb-2">
        <div class="mx:flex sm:block justify-between mx:mb-6 sm:mb-2">
          <div class="font-bold text-[#00629A] text-[20px]">{{ "TARGET_ACHIEVEMENT" | translate }}</div>
      
        </div>
          <target-achievement></target-achievement>
      </div>
    </div>
    <div class="dealer-portal__right mx:w-[25%] sm:w-[100%] mx:p-6 sm:p-4">
      <div class="banner__image mx:block sm:hidden">
        <nz-carousel [nzEffect]="effect" [nzAutoPlay]="true" [ngStyle]="carouselImageStyle">
            <div 
              nz-carousel-content 
              class="cursor-pointer"
              *ngFor="let item of carouselList">
                  <div class="flex justify-center">
                      <img [src]="item.imageBase64"   [ngStyle]="carouselImageStyle" />
                  </div>
            </div>
        </nz-carousel>
      </div>
      <portal-right-section></portal-right-section>
    </div>
  </div>
</div>
